module.exports = __webpack_public_path__ + "static/media/ui.bdc6f01d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/work/ui.png
// module id = 56
// module chunks = 0